import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { PaymentLinksSVG, MovementsSVG } from '../../../components';
import { useTranslation } from 'react-i18next';
import { checkPermissions } from '../../../helpers/PermissionsChecker';
import { ROUTES } from '../../../constants/routes/routes';

export default function LinksDropMenu () {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const paymentLinksRoute = ROUTES.PRODUCTS.PAYMENT_LINKS.BASE;
    const paymentMovementsRoute = ROUTES.PRODUCTS.PAYMENT_LINKS.MOVEMENTS;

    const handleRoute = (path) => {
        history.push(path);
    };
    return (
        <div className='dropMenu'>
            <div>
                { checkPermissions('show_products.show_links.sub_links') &&
                    <Button
                        className={location.pathname === paymentLinksRoute ? 'button_subMenuActive' : 'button_subMenu'}
                        onClick={() => { handleRoute(paymentLinksRoute); }}
                    >
                        <Stack direction={'row'} spacing={1} alignItems='center'>

                            {location.pathname === paymentLinksRoute ? <PaymentLinksSVG customStroke='white'/> : <PaymentLinksSVG/>}
                            <span className={location.pathname === paymentLinksRoute ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('paymentLinks.title')}</span>
                        </Stack>
                    </Button>
                }
                {checkPermissions('show_products.show_links.sub_payments') &&
                    <Button
                        className={location.pathname === paymentMovementsRoute ? 'button_subMenuActive' : 'button_subMenu'}
                        onClick={() => { handleRoute(paymentMovementsRoute); }}
                    >
                        <Stack direction={'row'} spacing={1} alignItems='center'>

                            {location.pathname === paymentMovementsRoute ? <MovementsSVG customStroke='white'/> : <MovementsSVG/>}
                            <span className={location.pathname === paymentMovementsRoute ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('paymentMovements.title')}</span>
                        </Stack>
                    </Button>
                }
            </div>
        </div>
    );
}
